import { RowWrapper, ContainerWrapper, SearchWrapper, List, InputWrapper } from "./Search.styles"
import { TextInput } from "components/TextInput"
import { InputLabel } from "features/MealPlan/components/InputLabel"
import { Text } from "components/Text"
import { useState, useEffect, ChangeEventHandler, useRef } from "react"

export type SearchInputProps= {
    label?: string
    placeholder: string
    items: searchItemProp[]
    onSelect: (item: searchItemProp) => void;
    width?: string
}

export type searchItemProp = {
    label: string
    value: string
} 

export const Search = ({
    label = '',
    placeholder,
    items,
    onSelect,
    width = '100%'
}: SearchInputProps) => { 

    const [query, setQuery] = useState<string>('')
    const [queryResults, setQueryResults] = useState<searchItemProp[]>([])
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [isFocus, setIsFocus] = useState<boolean>(false)
    const [listHeight, setListHeight] = useState<number>(180)

    const handleQuery: ChangeEventHandler<HTMLInputElement> = (e) => {
        setQuery(e.target.value)
        const filteredItems: searchItemProp[] = items.filter((item) => item.label.replace(/[_-]/g, ' ').toLowerCase().includes(query.toLowerCase()))
        setQueryResults(filteredItems)
        const totalResults:number = filteredItems.length
        setListHeight(() => totalResults > 4 ? 180 : totalResults * 36)
    }

    const handleSelect = (item: searchItemProp) => onSelect(item)
    

    const Row = ({ index, style} : { index: number, style: React.CSSProperties }) => {
        const item = queryResults[index]
        return (
            <RowWrapper onClick={() => handleSelect(item)} style={style}>
                {item?.label}
            </RowWrapper> 
        )
    }

    const handleClickOutside = (event: MouseEvent) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
            setIsFocus(false)
        } else {
            setIsFocus(true)
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        }
    }, []);

    useEffect(() => setQueryResults(items), [items])

    return (
      <>
        <ContainerWrapper>
          <SearchWrapper css={{ maxWidth: width }} ref={wrapperRef}>
            {label && <Text>{label}</Text>}
            <InputWrapper>
                <TextInput
                    outerLabel={InputLabel}
                    style={{marginTop: 0}}
                    label=''
                    displayLabel={false}
                    onChange={handleQuery}
                    autoComplete="off"
                    type="search"
                    displayHelperText={false}
                    placeholder={placeholder}
                    css={{marginTop: '0px !important'}}
                />
            </InputWrapper>
            {isFocus && query && (
                <List
                  height={listHeight}
                  itemCount={queryResults?.length || 0}
                  itemSize={40}
                  width="100%"
                  itemData={queryResults}
                  style={{ borderRadius: '8px' }}
                >
                  {Row}
                </List>
            )}
          </SearchWrapper>
        </ContainerWrapper>
      </>
    )
}
